import type { LatLng, ReportType, RoadReport } from "./types";
import { distanceMeters } from "./navigation";

export const reportLabels: Record<ReportType, string> = {
  POLICE: "משטרה",
  CAMERA: "מצלמה",
  FIXED_CAMERA: "מצלמת דרך קבועה",
  MOBILE_CAMERA: "מצלמת דרך ניידת",
  SLIPPERY_ROAD: "כביש מחליק",
  OBJECT_ON_ROAD: "עצם על הכביש",
  HAZARD: "סכנה בדרך",
  ACCIDENT: "תאונה",
  TRAFFIC: "עומס תנועה",
  CLOSURE: "חסימת כביש",
};

export function isCameraReport(type: ReportType): boolean {
  return ["CAMERA", "FIXED_CAMERA", "MOBILE_CAMERA"].includes(type);
}
export function isDangerReport(type: ReportType): boolean {
  return [
    "HAZARD",
    "ACCIDENT",
    "CLOSURE",
    "SLIPPERY_ROAD",
    "OBJECT_ON_ROAD",
  ].includes(type);
}
export function matchesReportType(
  actual: ReportType,
  requested: ReportType,
): boolean {
  return requested === "CAMERA" ? isCameraReport(actual) : actual === requested;
}
export function observationCandidates(
  reports: RoadReport[],
  here: LatLng,
  type: ReportType,
): RoadReport[] {
  return reports
    .filter(
      (r) =>
        matchesReportType(r.type, type) &&
        (r.expiresAt === null || r.expiresAt > Date.now()) &&
        distanceMeters(here, r) <= 500,
    )
    .sort((a, b) => distanceMeters(here, a) - distanceMeters(here, b));
}
/** An explicit on-screen question takes precedence. Otherwise do not guess between nearby cameras. */
export function observationTarget(
  reports: RoadReport[],
  here: LatLng,
  type?: ReportType,
  question?: RoadReport | null,
): { target?: RoadReport; ambiguous: boolean } {
  const selected = question && reports.find((r) => r.id === question.id);
  if (
    selected &&
    (selected.expiresAt === null || selected.expiresAt > Date.now()) &&
    (!type || matchesReportType(selected.type, type)) &&
    distanceMeters(here, selected) <= 500
  )
    return { target: selected, ambiguous: false };
  if (!type) return { ambiguous: false };
  const candidates = observationCandidates(reports, here, type);
  if (
    isCameraReport(type) &&
    candidates.length > 1 &&
    distanceMeters(here, candidates[1]) - distanceMeters(here, candidates[0]) <
      50
  )
    return { ambiguous: true };
  return { target: candidates[0], ambiguous: false };
}
